import { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import PrizeModal from "../../components/PrizeModal";
import WheelOfPrizes from "./WheelOfPrizes";
import generateReward from "../../controllers/account/generateReward";
import Paths from "../../router/Paths";
import { useDispatch } from "react-redux";
import { setResult } from "../../reducers/userReducer";

const segments = [
  { name: "Cap", code: "cap", color: "#f59e0b" },
  { name: "T-Shirt", code: "shirt", color: "#ef4444" },
  { name: "Writing Pad", code: "pad", color: "#06b6d4" },
  { name: "1,000 Airtime", code: "airtime1k", color: "#9333ea" },
  { name: "Mystery Gift", code: "mystery", color: "#b28a00" },
  { name: "Subscription 3 Months", code: "sub3", color: "#1f2937" },
  { name: "5,000 Airtime", code: "airtime5k", color: "#0a0a0a" },
  { name: "Try Again", code: "try", color: "#ffffff" },
];

function SpinSpinnerSection() {
  const dispatch = useDispatch();
  const wheelRef = useRef();
  const [resultItem, setResultItem] = useState("try");

  const [modal, setModal] = useState(false);
  const navigate = useNavigate();

  const handleSpin = async () => {
    // Phase 1: start spinning right away
    wheelRef.current?.startSpin();

    const result = await generateReward();

    const item = result?.data?.data;
    if (item) {
      dispatch(setResult(item));
    }
    // Backend responds with the prize code
    setResultItem(item?.reward || "try");
    const backendResult = { code: item?.reward || "try" };

    wheelRef.current?.resolveSpin(backendResult.code);
  };

  const handleFinish = ({ code }) => {
    setTimeout(
      () => {
        setModal(true);
      },
      code === "true" ? 500 : 1500
    );
  };
  // lightweight, on-demand confetti
  const fireConfetti = async () => {
    const confetti = (await import("canvas-confetti")).default;

    const duration = 1400; // total time ms
    const animationEnd = Date.now() + duration;
    const defaults = {
      startVelocity: 35,
      spread: 360,
      ticks: 90,
      zIndex: 9999,
    };

    function randomInRange(min, max) {
      return Math.random() * (max - min) + min;
    }

    (function frame() {
      const timeLeft = animationEnd - Date.now();
      if (timeLeft <= 0) return;

      const particleCount = 40 * (timeLeft / duration);
      // two bursts from left/right to feel fuller
      confetti({
        ...defaults,
        particleCount,
        origin: { x: randomInRange(0.2, 0.3), y: randomInRange(0.2, 0.4) },
      });
      confetti({
        ...defaults,
        particleCount,
        origin: { x: randomInRange(0.7, 0.8), y: randomInRange(0.2, 0.4) },
      });

      requestAnimationFrame(frame);
    })();
  };

  return (
    <section className="w-full min-h-screen flex flex-col items-center justify-start pt-10 ">
      <PrizeModal
        open={modal}
        setOpen={setModal}
        code={resultItem}
        onClaim={() => {
          navigate(Paths.claim);
        }}
        onTryAgain={() => {
          handleSpin();
        }}
      />

      {/* Heading */}
      <div className="w-full max-w-xs text-center">
        <h2 className="text-2xl font-extrabold tracking-wide">AKWAABA 2025</h2>
        <p className="mt-2 text-xl font-black">Spin &amp; Win</p>
      </div>

      <WheelOfPrizes
        ref={wheelRef}
        segments={segments}
        extraTurns={4} // ensures ≥ 4 full turns before landing
        settleDuration={4500} // how long the slow-down takes
        onFinish={(seg) => {
          // console.log("Landed on:", seg);
          if (seg?.code !== "try") {
            fireConfetti(); // 🎉 right here
          }
          handleFinish({ code: seg?.code });
        }}
      />

      {/* Spin button */}
      <div className="w-full mt-6">
        <button
          className="w-full rounded-md py-3 text-white font-semibold shadow-sm active:scale-[.99]
                     bg-primary1 "
          type="button"
          title="Wheel coming soon"
          onClick={() => {
            // navigate(Paths.claim);
            // setModal(true);
            handleSpin();
          }}
        >
          Spin
        </button>
      </div>

      {/* Learn more */}
      <div className="w-full max-w-xs text-center mt-5">
        <p className="text-gray-700">
          Learn more about{" "}
          <a
            href="https://www.intraverse.africa/"
            rel="noreferrer"
            target="_blank"
            className="text-primary1 underline"
          >
            Intraverse
          </a>
        </p>
      </div>
    </section>
  );
}

export default SpinSpinnerSection;
